import axios from 'axios';
import router from '../router';
// import router from "../router";
import Vue from 'vue';
import {
  courseUrl,
  orderUrl,
  basestoreUrl,
  mealUrl,
  templateUrl,
  daycareUrl
  // goodsUrl
} from './httpBaseUrl';
import store from '../store';
import { refundErrTextDeal, confirmErrTextDeal, dealErrText } from '../utils/utils';

const courseUrlArr = courseUrl();
const orderUrlArr = orderUrl();
const basestoreUrlArr = basestoreUrl();
const mealUrlArr = mealUrl();
const templateArr = templateUrl();
const daycareArr = daycareUrl();
const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000,
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie这些
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

/**
 * 430-v2.0版本
 * 取消了页面的上的分端，以用户的身份作为区分( 5个身份)
 * admin-管理员 org-机构(服务) school-学校 parent-家长 edu-教育局
 */
const theUserIdentity = localStorage.getItem('theUserIdentity');

// 添加请求拦截器
http.interceptors.request.use(
  (config) => {
    // if (config.url === '/userOrder/refund') {
    //   config.headers = 'application/json';
    // }
    if (localStorage.getItem('htmall_is_login')) {
      config.headers['token'] = localStorage.getItem('loginToken');
      // config.headers['token'] = 'eyJ0eXAiOiJqd3QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRfaXAiOiIxOTIuMTY4LjMuMSIsImV4cCI6MTYzODc3Mzg2MywiaWF0IjoxNjM2MDk1NDAzLCJhdXRoZW50aWNhdGlvbiI6IntcImRldGFpbHNcIjpudWxsLFwiYXV0aGVudGljYXRlZFwiOnRydWUsXCJwcmluY2lwYWxcIjpcIntcXFwidXNlcklkXFxcIjpcXFwiNjExMTMzMzY3NDcxMjY3ODQwXFxcIixcXFwidXNlck5hbWVcXFwiOlxcXCJ3c25kXFxcIixcXFwibmFtZVB5SW5pdGlhbFxcXCI6XFxcIndzbmRcXFwiLFxcXCJsb2dpbkFjY3RJZFxcXCI6XFxcIjYxMTEzMzM2NzQzMzUxOTEwNFxcXCIsXFxcInBob25lTm9cXFwiOm51bGwsXFxcInVzZXJUeXBlXFxcIjo1LFxcXCJ1c2VyU3RzXFxcIjoxLFxcXCJjb2RlXFxcIjpcXFwiXFxcIixcXFwib3JnSWRcXFwiOlxcXCI2MTExMzMzNjY5MTM0MjU0MDhcXFwiLFxcXCJvcmdOYW1lXFxcIjpcXFwi5a6P5aSn5aSnXFxcIixcXFwib3JnVHlwZVxcXCI6NixcXFwibG9nb0lkXFxcIjpudWxsLFxcXCJzY2hQZXJpb2RcXFwiOjAsXFxcImJpcnRoRGF5XFxcIjpudWxsLFxcXCJpZGVudGl0eVR5cGVcXFwiOjAsXFxcImlkZW50aXR5Tm9cXFwiOlxcXCJcXFwiLFxcXCJlbWFpbFxcXCI6XFxcIjEyMzQ1NkBxcS5jb21cXFwiLFxcXCJqb2luTW9kZVxcXCI6MCxcXFwicG9zdFxcXCI6XFxcIuezu-e7n-euoeeQhuWRmFxcXCIsXFxcImNhbmRpZGF0ZU5vXFxcIjpcXFwiXFxcIixcXFwiYmVnaW5EYXRlXFxcIjpudWxsLFxcXCJlbmREYXRlXFxcIjpudWxsLFxcXCJjcmVhdGVUaW1lXFxcIjpcXFwiMjAyMS0wOC0xNCAwOTo0NTo0OVxcXCIsXFxcImNyZWF0b3JJZFxcXCI6XFxcIjIwMjEwNzE2MDAxXFxcIixcXFwiY3JlYXRvck5hbWVcXFwiOlxcXCJ0ZWExXFxcIixcXFwib3BlcmF0ZVRpbWVcXFwiOlxcXCIyMDIxLTEwLTEyIDA5OjQwOjQ4XFxcIixcXFwib3BlcmF0b3JJZFxcXCI6XFxcIjYxMTEzMzM2NzQ3MTI2Nzg0MFxcXCIsXFxcIm9wZXJhdG9yTmFtZVxcXCI6XFxcIndzbmRcXFwiLFxcXCJyZWxcXFwiOm51bGx9XCIsXCJuYW1lXCI6XCJ6aHh5YmFzaWNcIixcImNyZWRlbnRpYWxzXCI6bnVsbCxcImF1dGhvcml0aWVzXCI6bnVsbH0ifQ.aFIQ5fzrzHxAJDKR141bK057cl7uMRnGaZ_TolJxFWc';
    }
    // 课程相关
    courseUrlArr.forEach((item) => {
      if (item === config.url) {
        config.baseURL = process.env.VUE_APP_API_COURSE_URL;
        // config.baseURL = process.env.VUE_APP_API_TEMPLATE;
      }
    });
    // 订单相关
    orderUrlArr.forEach((item) => {
      if (item === config.url) {
        config.baseURL = process.env.VUE_APP_API_ORDER_URL;
      }
    });
    // 基础库相关
    basestoreUrlArr.forEach((item) => {
      if (item === config.url) {
        config.baseURL = process.env.VUE_APP_API_BASESTORE_URL;
        // config.baseURL = process.env.VUE_APP_API_TEMPLATE;
      }
    });
    // 订餐相关
    mealUrlArr.forEach((item) => {
      if (item === config.url) {
        config.baseURL = process.env.VUE_APP_API_MEAL_URL;
      }
    });
    // 模板相关
    templateArr.forEach((item) => {
      if (item === config.url) {
        // config.baseURL = process.env.VUE_APP_API_TEMPLATE;
        config.baseURL = process.env.VUE_APP_API_COURSE_URL;
      }
    });
    // 托管
    daycareArr.forEach((item) => {
      if (item === config.url) {
        // config.baseURL = process.env.VUE_APP_API_TEMPLATE;
        config.baseURL = process.env.VUE_APP_API_COURSE_URL;
      }
    });
    if (config.url.indexOf('dailysupplyinfos') !== -1) {
      config.baseURL = process.env.VUE_APP_API_MEAL_URL;
    }
    if (config.url.indexOf('dishinfos') !== -1) {
      config.baseURL = process.env.VUE_APP_API_MEAL_URL;
    }
    // 根据用户身份改写url
    if (config.url.indexOf('theUserIdentity') !== -1) {
      config.url = config.url.replace(
        'theUserIdentity',
        store.state.theUserIdentity
      );
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 错误提示不用toast提示的接口列表
const errTipsArr = [`/${theUserIdentity}/batchRefund/startClassFailRefund`, `/${theUserIdentity}/requestRefundSheet/add`, `/${theUserIdentity}/requestRefundSheet/confirm`, `/${theUserIdentity}/requestRefundSheet/revoke`, `/${theUserIdentity}/requestRefundSheet/removeItems`, `/${theUserIdentity}/requestRefundSheet/appendItems`];

// 添加响应拦截器
http.interceptors.response.use(
  (res) => {
    // code 9001 非登录或登录失效

    if (res.config.responseType === 'blob') {
      return res;
    }

    if (res.data) {
      if (res.data.status === 401) {
        Vue.prototype.$Message.warning(
          res.data.error
            ? res.data.error
            : `请求出错，请稍后重试！错误码：${res.data.status}`
        );
        localStorage.setItem('oldUserInfo', localStorage.getItem('userInfo'));
        localStorage.removeItem('htmall_is_login');
        localStorage.removeItem('userInfo');
        router.push({
          name: 'passport_login',
          query: { portOrg: localStorage.getItem('portOrg') }
        });
      } else {
        if (res.data.status === 170081) {
          const { errWay, errName } = res.config;
          // const errDealText = refundErrTextDeal(res.data.error);
          const errArr = dealErrText(res.data.error);
          let content = '';
          if (errWay && errName) {
            content = `<p>${errWay}中的${errName}中（${errName}ID ：${errArr[1]}）存在已绑定退款申请单的课程，且<span style="color:red">已通过确认</span>审批，请通过<span style="color:red">【售后管理】-【退款申请单】</span>进行申请单处理</p><p style="padding-top:30px">涉及的退款申请单如下</p>
            <p style="padding-top:10px">${errArr[0]}</p>`;
          } else {
            content = `<p>课程中的节次已绑定退款申请单的课程，且<span style="color:red">已通过确认</span>审批，请通过<span style="color:red">【售后管理】-【退款申请单】</span>进行申请单处理</p><p style="padding-top:30px">涉及的退款申请单如下</p>
            <p style="padding-top:10px">${errArr[0]}</p>`;
          }
          setTimeout(() => {
            Vue.prototype.$Modal.info({
              title: '提示',
              width: 600,
              content: content
            });
          }, 500);
        } else if (res.data.status === 170082 || res.data.status === 6028) {
          const { errWay, errName } = res.config;
          // const errDealText = confirmErrTextDeal(res.data.error);
          const errArr = dealErrText(res.data.error);
          let content = '';
          if (errWay && errName) {
            content = `<p>${errWay}中的${errName}中（${errName}ID ：${errArr[1]}）存在已绑定退款申请单的课程，且<span style="color:red">未通过确认</span>审批，请通过<span style="color:red">【售后管理】-【退款申请单】</span>进行申请单确认</p><p style="padding-top:30px">涉及的退款申请单如下</p>
            <p style="padding-top:10px">${errArr[0]}</p>`;
          } else {
            content = `<p>课程中的节次已绑定退款申请单的课程，且<span style="color:red">未通过确认</span>审批，请通过<span style="color:red">【售后管理】-【退款申请单】</span>进行申请单确认</p><p style="padding-top:30px">涉及的退款申请单如下</p>
            <p style="padding-top:10px">${errArr[0]}</p>`;
          }
          setTimeout(() => {
            Vue.prototype.$Modal.info({
              title: '提示',
              width: 600,
              content: content
            });
          }, 500);
        } else if (
          res.data.status !== 200 &&
          res.data.status != 4802 &&
          !errTipsArr.includes(res.config.url)
        ) {
          Vue.prototype.$Message.warning({
            duration: 2.0,
            content: res.data.error
              ? res.data.error
              : `请求出错，请稍后重试！错误码：${res.data.status}`
          });
        }
      }
    } else {
      Vue.prototype.$Message.error('请求服务器出错！');
    }

    return res;
  },
  (error) => {
    // 服务器返回不是 2 开头的情况，会进入这个回调
    // 可以根据后端返回的状态码进行不同的操作
    // const responseCode = error.response.status;
    // 断网 或者 请求超时 状态

    if (!error.response) {
      // 请求超时状态
      if (error.message.includes('timeout')) {
        Vue.prototype.$Message.error('请求超时，请检查网络是否连接正常');
      } else {
        // Vue.prototype.$Message.error("请求失败，请检查网络是否已连接");
      }
      return;
    }
    if (error.response.status == 401) {
      Vue.prototype.$Message.warning(`登录失效，请重新登录～`);
      localStorage.setItem('oldUserInfo', localStorage.getItem('userInfo'));
      localStorage.removeItem('htmall_is_login');
      localStorage.removeItem('userInfo');
      router.push({
        name: 'passport_login',
        query: { portOrg: localStorage.getItem('portOrg') }
      });
    }
    return Promise.reject(error);
  }
);

export default http;
